/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=64a04312&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=64a04312&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a04312"]])

export default __exports__